import React from 'react';

import { $image_url, User } from 'js/utils';

type Props = {
  color?: 'gold' | 'white';
};

const PremiumLock = ({ color = 'gold' }: Props) => {
  if (User.current?.premium) {
    return null;
  } else if (color === 'gold') {
    return <img src={$image_url('premium/Lock-NoCircle-Gold.svg')} />;
  } else if (color === 'white') {
    return <img src={$image_url('premium/Lock-NoCircle-White.svg')} />;
  } else {
    return null;
  }
};

export default PremiumLock;
